import { Component } from 'react';
import { SearchType, TextKey } from '@mews-commander/enums';
import { ListItem, Tag } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { scrollIntoView } from '@mews-commander/utils';

interface Props {
    focused: boolean;
    result: $TSFixMe; // TODO: pt.instanceOf(SearchResult)
    onClick?: $TSFixMeFunction;
    showInvoiceableTag: boolean;
}

export default class Result extends Component<Props> {
    resultElement: $TSFixMe;

    componentDidUpdate() {
        if (this.props.focused) {
            scrollIntoView(this.resultElement);
        }
    }

    handleClick = () => {
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        this.props.onClick(this.props.result);
    };

    resultElementRef = (c: $TSFixMe) => (this.resultElement = c);

    render() {
        const { focused, result, showInvoiceableTag } = this.props;
        const { options, title, description, searchType, id } = result;
        const { isInvoiceable = false } = options;

        const isCompanyInvoiceable = isInvoiceable && searchType === SearchType.Company && showInvoiceableTag;
        const invoiceableTag = isCompanyInvoiceable
            ? {
                  rightItem: (
                      <Tag variant="denim">
                          <LocalizedText textKey={TextKey.Invoiceable} upperCase />
                      </Tag>
                  ),
              }
            : {};

        return (
            <ListItem
                primaryText={title}
                secondaryText={description}
                data-test-result
                data-test-search-type={searchType}
                data-test-new-entity={id === null}
                innerRef={this.resultElementRef}
                focused={focused}
                onClick={this.handleClick}
                {...invoiceableTag}
                {...options}
            />
        );
    }
}
